import { useDeparture } from "./../../hooks/useDeparture/useDeparture";

import { Direction } from "./../Direction/Direction";

export const Departure = () => {
  const [data, loading] = useDeparture(window.cityCode);

  // console.log(data);

  let schedules =
    data && data.map((elem, i) => <Direction schedule={elem} key={i} />);

  return (
    <>
      {/* <h2>Вылеты</h2> */}
      {data && schedules}
      {loading && <div>loading...</div>}
    </>
  );
};
